import React from 'react';

const svgProps = { fill: 'none', stroke: 'currentColor', strokeWidth: 2 };

export function TocIconIntro() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </svg>
  );
}

export function TocIconResumen() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M16 2v4h4M8 4h4M8 10h8M8 14h8" />
    </svg>
  );
}

export function TocIconActividad() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  );
}

export function TocIconEventos() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}

export function TocIconHitos() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <path d="M22 4L12 14.01l-3-3" />
    </svg>
  );
}

export function TocIconParticipadas() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  );
}

export function TocIconCalendario() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}

export function TocIconAnexos() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  );
}

const TOC_ICONS = {
  introduccion: TocIconIntro,
  'resumen-ejecutivo': TocIconResumen,
  'actividad-inversion': TocIconActividad,
  eventos: TocIconEventos,
  indicadores: TocIconHitos,
  participadas: TocIconParticipadas,
  calendario: TocIconCalendario,
  anexos: TocIconAnexos
};

export function TocIcon({ id }) {
  const Icon = TOC_ICONS[id];
  return Icon ? <span className="toc-icon" aria-hidden="true"><Icon /></span> : null;
}

/* Hito (check circle) - usado en cada ítem de hitos */
export function HitoIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" {...svgProps}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <path d="M22 4L12 14.01l-3-3" />
    </svg>
  );
}

/* KPIs - ingresos, gastos, runway, personas, ronda */
export function KpiIconIngresos() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}

export function KpiIconGastos() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M12 2v20M6 12h12M6 19h12" />
    </svg>
  );
}

export function KpiIconRunway() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}

export function KpiIconPersonas() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H11a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function KpiIconRonda() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function ValoracionIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <path d="M12 20V10M18 20V4M6 20v-4" />
    </svg>
  );
}

/* Eventos Q4 list (reloj) */
export function EventoQ4Icon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...svgProps}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}
